import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { login } from 'src/actions/auth';
import { getGrantsFromCookie } from 'src/actions/currentUser';
import { AUTH_ROUTE, EMAIL_VERIFICATION_ROUTE_PREFIX, SSO_AUTH_ROUTE } from 'src/constants';
import authCookie from 'src/helpers/authCookie';
import sessionEmitter from 'src/helpers/sessionEmitter';

export class AuthenticationGate extends Component {
  componentDidMount() {
    const { auth } = this.props;

    if (auth.loggedIn && auth.token) {
      return;
    }

    const foundCookie = authCookie.get();
    if (foundCookie) {
      this.props.login({ authData: foundCookie });
      this.props.getGrantsFromCookie(foundCookie);
    }
  }

  componentDidUpdate(oldProps) {
    const { account, auth, history, location = {} } = this.props;

    // if logging out (exclude routes that handle their own post-logout flow)
    if (
      ![AUTH_ROUTE, SSO_AUTH_ROUTE].includes(location.pathname) &&
      !location.pathname?.startsWith(EMAIL_VERIFICATION_ROUTE_PREFIX) &&
      oldProps.auth.loggedIn &&
      !auth.loggedIn
    ) {
      history.push({
        pathname: AUTH_ROUTE,
        state: {} // explicitly clear router state on log out
      });
    }

    if (oldProps.account.status !== 'terminated' && account.status === 'terminated') {
      sessionEmitter.emitLogout();
    }
  }

  render() {
    return null;
  }
}

export default withRouter(
  connect(({ auth, account }) => ({ auth, account }), {
    login,
    getGrantsFromCookie
  })(AuthenticationGate)
);
